import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import { PropTypes } from "prop-types";
import resolveIncludes from "./resolveIncludes";
import mergeComponentAndThemeStyles from "./mergeComponentAndThemeStyles";
import normalizeStyle from "./StyleNormalizer/normalizeStyle";
var THEME_STYLE = "@@shoutem.theme/themeStyle";
var THEME_STYLE_CACHE = "@@shoutem.theme/themeCachedStyle";
var defaultTheme;

var resolveStyle = function resolveStyle(style, baseStyle) {
  return normalizeStyle(resolveIncludes(style, baseStyle));
};

var Theme = function () {
  function Theme(themeStyle) {
    _classCallCheck(this, Theme);

    this[THEME_STYLE] = resolveStyle(themeStyle);
    this[THEME_STYLE_CACHE] = {};
  }

  _createClass(Theme, [{
    key: "createComponentStyle",
    value: function createComponentStyle(componentName, defaultStyle) {
      if (this[THEME_STYLE_CACHE][componentName]) {
        return this[THEME_STYLE_CACHE][componentName];
      }

      var componentIncludedStyle = resolveStyle(defaultStyle, this[THEME_STYLE]);
      this[THEME_STYLE_CACHE][componentName] = mergeComponentAndThemeStyles(componentIncludedStyle, this[THEME_STYLE][componentName], this[THEME_STYLE]);
      return this[THEME_STYLE_CACHE][componentName];
    }
  }], [{
    key: "setDefaultThemeStyle",
    value: function setDefaultThemeStyle(style) {
      defaultTheme = new Theme(style);
    }
  }, {
    key: "getDefaultTheme",
    value: function getDefaultTheme() {
      if (!defaultTheme) {
        defaultTheme = new Theme({});
      }

      return defaultTheme;
    }
  }]);

  return Theme;
}();

export { Theme as default };
export var ThemeShape = PropTypes.shape({
  createComponentStyle: PropTypes.func.isRequired
});